import React from "react";
import { Container, Row } from 'react-bootstrap';
import divImg from "../../images/line-div.png";

const PageTitles = ({ pageTitleSecond, pageTitleFirst, pageSubText }) => (
  <div className="pageTitles">
    <Container>
      <Row>
        <div className="hold-titles">

          {pageTitleSecond?.trim() && (
            <h2 className="second-title">{pageTitleSecond}</h2>
          )}

          {pageTitleFirst?.trim() && (
            <h1 className="first-title">{pageTitleFirst}</h1>
          )}

          {(pageTitleSecond?.trim() || pageTitleFirst?.trim()) && (
            <div className="hold-divImg">
              <img src={divImg} alt="line divider for page title text" />
            </div>
          )}

          {pageSubText?.trim() && (
            <h6 className="sub-title">{pageSubText}</h6>
          )}

        </div>
      </Row>
    </Container>
  </div>
);

export default PageTitles;